import { LRParser } from '@lezer/lr';
import { LRLanguage, LanguageSupport } from '@codemirror/language';
import { styleTags, tags } from '@lezer/highlight';

// This file was generated by lezer-generator. You probably shouldn't edit it.
const spec_identifier = {__proto__:null,import:14, include:16, module:18, def:22, as:26, break:28, label:30, reduce:32, foreach:34, if:38, then:40, elif:42, else:44, end:46, and:50, or:52, not:54, try:58, catch:60, true:64, false:66, null:70};
const parser = LRParser.deserialize({
  version: 14,
  states: "$bQYQPOOOOQO'#Ca'#CaO#fQPO'#DYO#mQPO'#D]O#tQPO'#D`OOQO'#De'#DeOOQO'#Da'#DaQYQPOOOOQO'#Cb'#CbOOQO'#Cf'#CfOOQO'#Ch'#ChOOQO'#Cn'#CnOOQO'#Ct'#CtOOQO'#Cx'#CxOOQO'#C{'#C{OOQO'#DO'#DOOOQO,59t,59tO#{QPO,59tOOQO,59w,59wO$SQPO,59wOOQO,59z,59zO$ZQPO,59zOOQO-E7_-E7_OOQO1G/`1G/`OOQO1G/c1G/cOOQO1G/f1G/f",
  stateData: "$e~O!WOSPOS~ORTOSTOVWOWWOXWOZXO]YO^YO_YO`YOaYOcZOdZOeZOfZOgZOi[Oj[Ok[Om]On]Op^Oq^Os_OtTOuTOvTOwTOxTOyTO{QO!ORO!RSO!YTO~Oz`O~PYO}bO~PYO!QdO~PYOzgO~PYO}hO~PYO!QiO~PYOSu~",
  goto: "#]!YPPPPP!Z!ePPP!eP!ePPPPP!ePPPPP!ePPP!ePP!ePP!ePPPPPPPPP!ZPP!ZPP!Z!oPPP#RaTOQRSVaceaPOQRSVaceQVOQaQQcRQeSXfVaceaUOQRSVace",
  nodeNames: "⚠ Comment Program String Number Keyword Import import include module Definition def Statement as break label reduce foreach Conditional if then elif else end LogicOperator and or not Exception try catch Boolean true false Null null Separator ArithmeticOperator UpdateOperator ComparisonOperator Variable Deref ] [ SquareBrackets ) ( Parentheses } { Braces",
  maxTerm: 56,
  nodeProps: [
    ["openedBy", 42,"[",45,"(",48,"{"],
    ["closedBy", 43,"]",46,")",49,"}"]
  ],
  skippedNodes: [0,1],
  repeatNodeCount: 1,
  tokenData: ")k~RmXY!|YZ!|]^!|pq!|rs#_st${tu%dxy&Ryz&Wz{&]{|&]|}&j}!O&o!O!P(S!P!Q&]!Q![&z![!]&j!]!^&j!^!_(X!_!`(f!`!a(X!c!}(l!}#O(}#P#Q)S#R#S(l#T#o(l#o#p)X#p#q)^#q#r)f~#RS!W~XY!|YZ!|]^!|pq!|~#bVOr#_rs#ws#O#_#O#P#|#P;'S#_;'S;=`$u<%lO#_~#|OR~~$PRO;'S#_;'S;=`$Y;=`O#_~$]WOr#_rs#ws#O#_#O#P#|#P;'S#_;'S;=`$u;=`<%l#_<%lO#_~$xP;=`<%l#_~%QSP~OY${Z;'S${;'S;=`%^<%lO${~%aP;=`<%l${~%gR!c!}%p#R#S%p#T#o%p~%uSx~!Q![%p!c!}%p#R#S%p#T#o%p~&WO!O~~&]O}~~&bPu~!_!`&e~&jOv~~&oOt~~&tQu~!Q![&z!_!`&e~'PRS~!O!P'Y!Q![&z#X#Y'k~']P!Q!['`~'eQS~!Q!['`#X#Y'k~'nQ}!O't!Q!['z~'wP!Q!['z~(PPS~!Q!['z~(XOy~~(^Pw~!_!`(a~(fOw~~(iP!_!`(a~(qS!Y~!Q![(l!c!}(l#R#S(l#T#o(l~)SO{~~)XOz~~)^O!R~~)cPt~!_!`&e~)kO!Q~",
  tokenizers: [0],
  topRules: {"Program":[0,2]},
  specialized: [{term: 56, get: (value) => spec_identifier[value] || -1}],
  tokenPrec: 156
});

const jqLanguage = LRLanguage.define({
    parser: parser.configure({
        props: [
            styleTags({
                String: tags.string,
                Number: tags.number,
                "import include module": tags.moduleKeyword,
                "true false": tags.bool,
                def: tags.definitionKeyword,
                "as break label reduce foreach if then elif else end try catch": tags.controlKeyword,
                null: tags.null,
                Separator: tags.separator,
                "( )": tags.paren,
                "[ ]": tags.squareBracket,
                "{ }": tags.brace,
                ArithmeticOperator: tags.arithmeticOperator,
                "and or not": tags.logicOperator,
                ComparisonOperator: tags.compareOperator,
                Identifier: tags.name,
                Comment: tags.comment,
                Deref: tags.derefOperator,
            }),
        ],
    }),
    languageData: {
        commentTokens: { line: "#" },
    },
});
function jq() {
    return new LanguageSupport(jqLanguage);
}

export { jq, jqLanguage };
